<template>
  <b-modal @hide="closeModal" ref="passwordChangeModal" :title="$t('パスワード変更')" size="lg">
    <loading :active.sync="isLoading" :loader="'dots'" :color="'#FFF'" :background-color="'#000'" :can-cancel="false" :is-full-page="true"></loading>
    <b-container fluid>
      <form class="form-horizontal" @submit.prevent="changePassword">
        <div class="bs-callout bs-callout-danger" style="margin-top: 0;">
          <h4 class="mb-0">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />&nbsp;{{ $t("パスワードの変更") }}
          </h4>
        </div>

        <table class="table table-bordered">
          <colgroup>
            <col width="30%" />
            <col width="70%" />
          </colgroup>
          <tbody>
            <tr>
              <th class="active">{{ $t("元のパスワード") }}</th>
              <td>
                <div class>
                  <input
                    type="password"
                    name="old_password"
                    autofocus
                    required
                    id="id_old_password"
                    v-model="old_password"
                    class="form-control"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th class="active">{{ $t("新しいパスワード") }}</th>
              <td>
                <div class>
                  <input
                    type="password"
                    name="new_password1"
                    required
                    id="id_new_password1"
                    v-model="new_password"
                    class="form-control"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th class="active">{{ $t("新しいパスワード(確認用)") }}</th>
              <td>
                <div class>
                  <input
                    type="password"
                    name="new_password2"
                    required
                    id="id_new_password2"
                    v-model="new_password_confirm"
                    class="form-control"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="alert alert-danger" v-if="error_message" role="alert">
          {{error_message}}
        </div>
      </form>
    </b-container>
    <template v-slot:modal-footer>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4">
          <button type="button" class="btn btn-primary mr-3" @click="changePassword()">
            <font-awesome-icon :icon="['fas', 'download']" />&nbsp;{{ $t("変更") }}</button>
          <button type="button" class="btn btn-light" @click="closeModal()">{{ $t("キャンセル") }}</button>
      </div>
    </template>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      error_message: '',
      isLoading: false,
      old_password: '',
      new_password: '',
      new_password_confirm: '',
      isComplate: false,
    }
  },
  methods: {
    changePassword() {
      if (this.old_password || this.new_password || this.new_password_confirm) {
        if (this.new_password === this.new_password_confirm) {
          if (this.new_password.length < 6) {
            this.error_message = this.$t('パスワードは6文字以上で入力して下さい')
            return
          }
          this.isLoading = true
          this.$store.dispatch('auth/changePassword', {newPassword: this.new_password, oldPassword: this.old_password}).then(() => {
            this.$toasted.success(this.$t('パスワードが変更されました'))
            this.closeModal()
          }).catch(() => {
            this.isLoading = false
            this.error_message = this.$t('データ更新エラーメッセージ')
          })
        } else {
          this.error_message = this.$t('パスワード確認不一致')
        }
      } else {
        this.error_message = this.$t('パスワード') + this.$t('必須メッセージ')
      }
    },
    openModal() {
      this.$refs.passwordChangeModal.show()
      this.isComplate = false
      this.error_message = ''
      this.isLoading = false
      this.old_password = ''
      this.new_password = ''
      this.new_password_confirm = ''
    },
    closeModal() {
      this.$refs.passwordChangeModal.hide()
      this.isComplate = false
      this.error_message = ''
      this.isLoading = false
      // this.isComplate = false;
      this.old_password = ''
      this.new_password = ''
      this.new_password_confirm = ''
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/_modal.scss";
@import "../assets/styles/_callout.scss";
th{
  font-size: 14px;
  background-color: #fafafa;
  vertical-align: middle;
}
td input{
  font-size: 14px;
}
</style>
